import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const ServiceFilter = ({ 
  selectedCategory, 
  setSelectedCategory, 
  selectedIndustry, 
  setSelectedIndustry,
  selectedSize,
  setSelectedSize,
  searchQuery,
  setSearchQuery,
  onReset
}) => {
  const categoryOptions = [
    { value: 'all', label: 'Toutes les catégories' },
    { value: 'Conseil', label: 'Conseil' },
    { value: 'Juridique', label: 'Juridique' },
    { value: 'Immobilier', label: 'Immobilier' },
    { value: 'Technologie', label: 'Technologie' },
    { value: 'Logistique', label: 'Logistique' },
    { value: 'Événementiel', label: 'Événementiel' }
  ];

  const industryOptions = [
    { value: 'all', label: 'Toutes les industries' },
    { value: 'mining', label: 'Mines & Ressources' },
    { value: 'finance', label: 'Finance & Banque' },
    { value: 'retail', label: 'Commerce & Distribution' },
    { value: 'manufacturing', label: 'Industrie & Production' },
    { value: 'services', label: 'Services Professionnels' },
    { value: 'ngo', label: 'ONG & Organisations' }
  ];

  const sizeOptions = [
    { value: 'all', label: 'Toutes les tailles' },
    { value: 'startup', label: 'Start-up (1-10)' },
    { value: 'small', label: 'PME (11-50)' },
    { value: 'medium', label: 'Moyenne (51-200)' },
    { value: 'large', label: 'Grande (200+)' }
  ];

  return (
    <div className="bg-white/80 dark:bg-slate-800/40 backdrop-blur-xl border border-slate-200 dark:border-white/10 rounded-3xl p-4 md:p-6 shadow-2xl mb-6 md:mb-8">
      <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4 mb-4">
        <h2 className="text-xl md:text-2xl font-bold text-slate-900 dark:text-white" style={{ fontFamily: 'var(--font-headline)' }}>
          Filtrer les services
        </h2>
        <Button
          variant="ghost"
          size="sm"
          iconName="RotateCcw"
          iconPosition="left"
          onClick={onReset}
          className="text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white hover:bg-slate-200 dark:hover:bg-slate-800"
        >
          Réinitialiser
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="relative">
          <Icon name="Search" size={20} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 dark:text-slate-400 pointer-events-none" />
          <input
            type="text"
            placeholder="Rechercher un service..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e?.target?.value)}
            className="w-full pl-10 pr-4 py-2.5 rounded-xl border border-slate-200 dark:border-white/10 bg-white dark:bg-slate-900/60 text-slate-900 dark:text-white placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500/30 transition-all"
          />
        </div>

        <Select
          options={categoryOptions}
          value={selectedCategory}
          onChange={setSelectedCategory}
          placeholder="Catégorie"
        />

        <Select
          options={industryOptions}
          value={selectedIndustry}
          onChange={setSelectedIndustry}
          placeholder="Industrie"
        />

        <Select
          options={sizeOptions}
          value={selectedSize}
          onChange={setSelectedSize}
          placeholder="Taille d'entreprise"
        />
      </div>
    </div>
  );
};

export default ServiceFilter;